export default {
  methods: {
    group(value) {
      let prepared = [];
      value.forEach(pc => {
        let group = prepared.find(group => group.id === pc.parent.name);
        if(group === undefined) {
          group = {
            id: pc.parent.name,
            code: pc.parent.name,
            name: pc.parent.name,
            children: []
          }
          prepared.push(group)
        }
        if (group.children.find(child => child.id === pc.id) === undefined) {
          group.children.push(pc);
        }
      })
      return prepared;
    }
  }
}
